/** Session flag: after login, force store picker when multiple stores exist. */
export const REQUIRE_STORE_PICK_KEY = 'aaa_require_store_pick';
export const WORKING_IN_STORE_TOAST_KEY = 'aaa_working_in_store_toast';

export function markRequireStorePickOnLogin() {
    try {
        sessionStorage.setItem(REQUIRE_STORE_PICK_KEY, '1');
        localStorage.removeItem('selectedStoreId');
        sessionStorage.removeItem('selectedStoreId');
        localStorage.removeItem('selectedStoreMode');
        sessionStorage.removeItem('selectedStoreMode');
        localStorage.removeItem('selectedWorkspaceId');
        sessionStorage.removeItem('selectedWorkspaceId');
    } catch {
        /* ignore storage errors */
    }
}

export function clearRequireStorePick() {
    try {
        sessionStorage.removeItem(REQUIRE_STORE_PICK_KEY);
    } catch {
        /* ignore */
    }
}

export function shouldRequireStorePick() {
    try {
        return sessionStorage.getItem(REQUIRE_STORE_PICK_KEY) === '1';
    } catch {
        return false;
    }
}
